export default __webpack_public_path__ + "static/media/Pessoa_juridica_on_light_blue.2d73f716.svg";